import { render, staticRenderFns } from "./charmPlanInfo.vue?vue&type=template&id=65260415"
import script from "./charmPlanInfo.vue?vue&type=script&lang=js"
export * from "./charmPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65260415')) {
      api.createRecord('65260415', component.options)
    } else {
      api.reload('65260415', component.options)
    }
    module.hot.accept("./charmPlanInfo.vue?vue&type=template&id=65260415", function () {
      api.rerender('65260415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/plan/charmPlanInfo.vue"
export default component.exports